import { Component, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center h-full gap-3 p-8">
          <div className="text-red-400 text-2xl">!</div>
          <div className="text-sm text-red-400 font-mono">Panel render error</div>
          <div className="text-xs text-term-textDim font-mono max-w-md text-center">
            {this.state.error?.message || 'Unknown error'}
          </div>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            className="mt-2 px-3 py-1 text-xs bg-term-bgLight text-term-text border border-term-border rounded hover:bg-term-bgDark transition-colors font-mono"
          >
            [ Retry ]
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
